import Typography from "@mui/material/Typography";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import HomePageContent from "../components/HomePageContent";

export const HomePage = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <HomePageContent />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Typography variant="h6">
          Please sign-in to access home page.
        </Typography>
      </UnauthenticatedTemplate>
    </>
  );
};
